module.exports = __webpack_public_path__ + "static/placeholder-0e9793c46eab7b0f9b2cdf60c2691f3a.jpg";